import * as React from 'react';
export default function useMemo(getValue, condition, shouldUpdate) {
  var cacheRef = React.useRef({});
  if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
    cacheRef.current.value = getValue();
    cacheRef.current.condition = condition;
  }
  return cacheRef.current.value;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-tabs/node_modules/rc-util/es/hooks/useMemo.js
// module id = 2182
// module chunks = 1